import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import snakecaseKeys from 'snakecase-keys';
import { useGetUserProfile } from 'hooks/queries/use-get-user-profile.hook';
import { setPostFtux, SetPostFtuxPayload } from 'api/set-post-ftux';

export const usePostFtux = () => {
  const { data, isLoading, error } = useGetUserProfile();
  const updateFtuxMutation = useMutation({
    mutationFn: async (payload: SetPostFtuxPayload) => {
      await setPostFtux(snakecaseKeys(payload));
    },
  });

  const markFeatureHighlightsComplete = useCallback(
    () =>
      updateFtuxMutation.mutateAsync({
        feature_highlights: true,
        onboarding_complete: false,
      }),
    [updateFtuxMutation],
  );

  return {
    featureHighlightsComplete: data?.memberPostFtux?.feature_highlights,
    isLoading: isLoading || updateFtuxMutation.isPending,
    error: error ?? updateFtuxMutation.error,
    markFeatureHighlightsComplete,
  };
};
